'use strict';

(function (numeral) {
	function AssetAdd($http, $stateParams, Upload, $i18next, pmtAlertService) {
		let $ctrl = this;

		$ctrl.site = $stateParams.site;
		$ctrl.files = [];
		$ctrl.errorFiles = [];
		$ctrl.finishedLoading = 0;
		$ctrl.shoeUploadError = false;

		$ctrl.closeBox = function () {
			$ctrl.onAssetAdded();
		};

		$ctrl.acceptFileTypes =
			'.jpg,.jpeg,.png,.gif,.3g2,.3gp,.3gpp,.asf,.avi,.dat,.divx,.dv,.f4v,.flv,.m2ts,.m4v,.mkv,.mod,.mov,.mp4,.mpe,.mpeg,.mpeg4,.mpg,.mts,.nsv,.ogm,.ogv,.qt,.tod,.ts,.vob,.wmv';

		$ctrl.upload = function (files) {
			const onlyValidFiles = (files || []).filter(
				x => x.type?.startsWith('image') || x.type?.startsWith('video')
			);
			$ctrl.files = onlyValidFiles.concat($ctrl.files);
			$ctrl.showUploadError = false;
			$ctrl.errorFiles = [];
			if (files && files.length) {
				$ctrl.showUploadingProgress = true;
				$ctrl.progressPercentage = 0;
				$ctrl.importData = null;
				$ctrl.uploadError = null;

				angular.forEach(files, function (file) {
					file.showUploadingProgress = false;

					if (file.size !== 0) {
						file.showUploadingProgress = true;
						file.isEditing = false;
						file.isVideo = false;
						file.uploadError = null;
						Upload.upload({ url: 'api/' + $ctrl.site + '/media', file: file })
							.progress(function (evt) {
								file.progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
							})
							.success(function (data) {
								file.showUploadingProgress = false;
								if (data.success) {
									file.media = data.data;
									file.id = data.data._id;
									$ctrl.finishedLoading++;
									if (data.data.contentType.startsWith('video')) {
										file.isVideo = true;
									}
								} else {
									file.uploadError = data.data;
									$ctrl.showUploadingProgress = false;
									$ctrl.showUploadError = true;
									$ctrl.errorFiles.push(file.name);
								}
							})
							.error(function () {
								$ctrl.showUploadingProgress = false;
								$ctrl.showUploadError = true;
							});
					} else {
						$ctrl.uploadError = $i18next.t('general.media_upload.file_size_zero');
						$ctrl.showUploadingProgress = false;
					}
				});

				$ctrl.formatSize = size => numeral(size).format('0.0b');

				$ctrl.toggleEditing = f => {
					if (!f.isEditing) {
						f.editName = f.media.name;
						f.editDescription = f.media.description;
					}
					f.isEditing = !f.isEditing;
				};

				$ctrl.cancelEdit = f => (f.isEditing = false);
				$ctrl.saveChanges = f => {
					let edited = {
						name: f.editName,
						description: f.editDescription
					};
					f.media.name = edited.name;
					f.media.description = edited.description;
					let assetId = f.media.id;

					$http
						.put(`api/${$ctrl.site}/media/asset/${assetId}`, edited)
						.then(() => (f.isEditing = false))
						.catch(e => pmtAlertService.errorAlert(e));
				};

				$ctrl.deleteMedia = assetId => {
					$http
						.delete(`api/${$ctrl.site}/media/purge/${assetId}`)
						.then(() => {
							$ctrl.finishedLoading--;
							$ctrl.files = $ctrl.files.filter(file => {
								return assetId !== file.id;
							});
						})
						.catch(e => pmtAlertService.errorAlert(e));
				};
			}
		};
	}

	AssetAdd.$inject = ['$http', '$stateParams', 'Upload', '$i18next', 'pmtAlertService'];

	angular.module('PinMeTo.fileManager').component('pmtAssetAdd', {
		templateUrl: 'pmtShared/filemanager/pmtAssetAdd.html',
		controller: AssetAdd,
		bindings: {
			onAssetAdded: '&'
		}
	});
})(window.numeral);
